// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, PinInput } from '@mantine/core';
import { useMantineTheme } from '@mantine/core';
import { Container, Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor, Badge } from '@/components/ui/core';
import { IconArrowLeft, IconSparkles } from '@tabler/icons-react';
import { FadeIn, SlideIn } from '@/components/animations';

export default function OtpGlassmorphism() {
  const [otp, setOtp] = useState('');
  const theme = useMantineTheme();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('OTP:', otp);
  };

  return (
    <Box
      style={{
        minHeight: '100vh',
        backgroundImage: 'url(https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
      }}
    >
      <Box
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(8px)',
        }}
      />

      <Box mih="100vh" py="xl" px="md" style={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center' }}>
        <Container size="xs" w="100%">
          <SlideIn direction="up" delay={100}>
            <Box
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(20px) saturate(180%)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: theme.radius.lg,
                padding: '2.5rem',
                boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
              }}
            >
              <Stack gap="lg">
                <Button
                  component={Link}
                  to="/app/demo/auth-pages/otp"
                  variant="subtle"
                  size="xs"
                  leftSection={<IconArrowLeft size={14} />}
                  w="fit-content"
                  c="white"
                >
                  Back to variants
                </Button>

                <FadeIn delay={200}>
                  <Stack gap="xs" align="center">
                    <Badge
                      leftSection={<IconSparkles size={12} />}
                      variant="white"
                      size="lg"
                      style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                      }}
                    >
                      Glassmorphism
                    </Badge>
                    <Title order={2} ta="center" c="white" mt="md">
                      Verify your identity
                    </Title>
                    <Text c="white" size="sm" ta="center" style={{ opacity: 0.9 }}>
                      We sent a 6-digit code to your email
                    </Text>
                  </Stack>
                </FadeIn>

                <SlideIn direction="up" delay={300}>
                  <form onSubmit={handleSubmit}>
                    <Stack gap="lg">
                      <Center>
                        <PinInput
                          length={6}
                          value={otp}
                          onChange={setOtp}
                          size="lg"
                          styles={{
                            input: {
                              backgroundColor: 'rgba(255, 255, 255, 0.1)',
                              backdropFilter: 'blur(10px)',
                              border: '1px solid rgba(255, 255, 255, 0.2)',
                              color: 'white',
                              fontSize: '1.5rem',
                              fontWeight: 600,
                              '&:focus': { borderColor: 'rgba(255, 255, 255, 0.4)' },
                            },
                          }}
                        />
                      </Center>

                      <Button
                        type="submit"
                        fullWidth
                        size="md"
                        variant="white"
                        style={{
                          backgroundColor: 'rgba(255, 255, 255, 0.9)',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        Verify code
                      </Button>
                    </Stack>
                  </form>
                </SlideIn>

                <FadeIn delay={400}>
                  <Stack gap="xs" align="center">
                    <Text size="sm" c="white" style={{ opacity: 0.9 }}>
                      Didn't receive the code?
                    </Text>
                    <Anchor size="sm" c="white" fw={500}>
                      Resend code
                    </Anchor>
                  </Stack>
                </FadeIn>
              </Stack>
            </Box>
          </SlideIn>
        </Container>
      </Box>
    </Box>
  );
}
